webpackJsonp([42849680786139],{

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var gatsby_link_1 = __webpack_require__(20);
	var React = __webpack_require__(1);
	var tinyhumantime_1 = __webpack_require__(66);
	var BlogPost = function BlogPost(props) {
	    var post = props.post;
	
	    var date = tinyhumantime_1.default(new Date(post.frontmatter.date), new Date()) + ' ago';
	    return React.createElement("article", { key: post.id, className: "blog__post blog__list__item " + props.className }, React.createElement("h3", { className: "blog__post__date", "data-tip": "Posted on " + post.frontmatter.date + "." }, date), React.createElement("h1", { className: "blog__post__title" }, React.createElement(gatsby_link_1.default, { to: post.frontmatter.path }, React.createElement("span", { dangerouslySetInnerHTML: { __html: post.frontmatter.title } }))), React.createElement("div", { className: "blog__post__content", dangerouslySetInnerHTML: { __html: post.html } }), React.createElement("p", { className: "blog__post__byline" }, "From ", post.frontmatter.author));
	};
	exports.default = BlogPost;

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var gatsby_link_1 = __webpack_require__(20);
	var React = __webpack_require__(1);
	var ReactTooltip = __webpack_require__(35);
	var BlogPost_1 = __webpack_require__(64);
	var Header_1 = __webpack_require__(14);
	var react_helmet_1 = __webpack_require__(22);
	var MailingListModal_1 = __webpack_require__(15);
	function Template(props) {
	  var markdownRemark = props.data.markdownRemark;
	  return React.createElement("div", { className: "page__blog__wrapper" }, React.createElement("div", { className: "page page__blog" }, React.createElement(ReactTooltip, { className: "tooltip", place: "bottom", "aria-haspopup": "true" }), React.createElement(Header_1.default, null), React.createElement(react_helmet_1.default, { title: markdownRemark.frontmatter.title }), React.createElement(gatsby_link_1.default, { className: "circlelink blog__post__solo__back", to: "/blog" }, "\u2190 All posts"), React.createElement(BlogPost_1.default, { className: "blog__post__solo", post: markdownRemark }), React.createElement(MailingListModal_1.default, null)));
	}
	exports.default = Template;
	exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 66:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var units = {
	    long: ['just now', 'nanosecond', 'microsecond', 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'year']
	};
	function tinyHumanTime(t1, t2) {
	    var u = 'long';
	    t1 = Array.isArray(t1) ? t1[0] * 1e3 + t1[1] / 1e6 : t1;
	    t2 = Array.isArray(t2) ? t2[0] * 1e3 + t2[1] / 1e6 : t2;
	    var milli = Math.abs(Number(isNaN(+t2) ? t1 : Number(t2) - Number(t1)));
	    if (milli === 0) {
	        return units[u][0];
	    }
	    if (milli < 1e-3) {
	        return format(Math.floor(milli * 1e6), units[u][1], u);
	    }
	    if (milli < 1) {
	        return format(Math.floor(milli * 1e3), units[u][2], u);
	    }
	    if (milli < 1000) {
	        return format(Math.floor(milli), units[u][3], u);
	    }
	    if ((milli /= 1000) < 60) {
	        return format(Math.floor(milli), units[u][4], u);
	    }
	    if ((milli /= 60) < 60) {
	        return format(Math.floor(milli), units[u][5], u);
	    }
	    if ((milli /= 60) < 24) {
	        return format(Math.floor(milli), units[u][6], u);
	    }
	    if ((milli /= 24) < 7) {
	        return format(Math.floor(milli), units[u][7], u);
	    }
	    if ((milli /= 7) < 52) {
	        return format(Math.floor(milli), units[u][8], u);
	    }
	    return format(Math.floor(milli / 52), units[u][9], u);
	}
	exports.default = tinyHumanTime;
	function format(n, unit, mode) {
	    return "" + (n + (mode === 'short' ? '' : ' ')) + unit + (mode === 'short' || n === 1 ? '' : 's');
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-template-tsx-b38bf5d34feb9245045f.js